export type VAssetClassSize = {
  standardMeasurementId: number,
  standardMeasurementName: string,
  unitOfAreaMeasurementId: number,
  unitOfAreaMeasurementAcronym: string,
  size: number
}

enum SizeMeasurements {
  SQM = 1,
  SQF = 2,
  ACRE = 3,
  HECTARE = 4
}

enum UnitMeasurement {
  IMPERIAL = 1,
  METRIC = 2
}

const CONST_F = 10.7639
const CONST_ACRE = 43560
const CONST_HECTARE = 107639.104167

export function sizeInfo(size: VAssetClassSize, preferredUnitMeasurement?: number): string {
  if (!size) {
    return 'Unknown'
  }

  const info: { sizeInF: number, sizeInM: number } = {
    sizeInF: null,
    sizeInM: null,
  }

  switch (size.unitOfAreaMeasurementId) {
    case SizeMeasurements.SQM: {
      info.sizeInF = size.size * CONST_F
      info.sizeInM = size.size
      break;
    }
    case SizeMeasurements.SQF: {
      info.sizeInF = size.size
      info.sizeInM = size.size / CONST_F
      break;
    }
    case SizeMeasurements.ACRE: {
      info.sizeInF = size.size * CONST_ACRE
      info.sizeInM = size.size / CONST_F
      break;
    }
    case SizeMeasurements.HECTARE: {
      info.sizeInF = size.size * CONST_HECTARE
      info.sizeInM = size.size / CONST_F
      break;
    }
  }

  if (info.sizeInF == null || info.sizeInM == null) {
    return 'Unknown'
  }

  const sizeInF = info.sizeInF.toLocaleString('en-US', { maximumFractionDigits: 2 })
  const sizeInM = info.sizeInM.toLocaleString('en-US', { maximumFractionDigits: 2 })

  return preferredUnitMeasurement && preferredUnitMeasurement == UnitMeasurement.IMPERIAL
    ? `${sizeInF} ft2 (${sizeInM} m2)`
    : `${sizeInM} m2 (${sizeInF} ft2)`
}

export function convertSize(value: number, srcUnitAreaMeasurementId: number, dstUnitAreaMeasurementId: number): number {
  let sizeInM = 0;
  switch (srcUnitAreaMeasurementId) {
    case SizeMeasurements.SQM: {
      sizeInM = value;
      break;
    }
    case SizeMeasurements.SQF: {
      sizeInM = value / CONST_F
      break;
    }
    case SizeMeasurements.ACRE: {
      const sizeInF = value * CONST_ACRE
      sizeInM = sizeInF / CONST_F
      break;
    }
    case SizeMeasurements.HECTARE: {
      const sizeInF = value * CONST_HECTARE
      sizeInM = sizeInF / CONST_F
      break;
    }
  }
  switch (dstUnitAreaMeasurementId) {
    case SizeMeasurements.SQM: {
      return sizeInM
    }
    case SizeMeasurements.SQF: {
      return sizeInM * CONST_F
    }
    case SizeMeasurements.ACRE: {
      return sizeInM / 4047
    }
    case SizeMeasurements.HECTARE: {
      return sizeInM / 10000
    }
  }
}